import { render, staticRenderFns } from "./gzTicketInfo.vue?vue&type=template&id=47aefb46&scoped=true&"
import script from "./gzTicketInfo.vue?vue&type=script&lang=js&"
export * from "./gzTicketInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47aefb46",
  null
  
)

export default component.exports